import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { del, get, patch, post } from "../../../services/API/ApiClient";
import { DefaultInProgressRequestBodyType } from "../../../constant/document";
import { notification } from "antd";
import { openNotification, openStaticErrorNotification } from "../../../components/Template/NotificationComponent";
import { autoRefreshFrequency } from "../../../constant/constant";

export const fetchInprogressAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchInprogressAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().InProgressAudiosState.currentRequestBody,
      ...getState().TranscribeState.filterValues,
      Keyword: getState().TranscribeState.searchKeyword,
    };
    dispatch(updateInProgressRequestBody(reqBody));

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Infinite Scrolling
export const fetchPaginateInprogressAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPaginateInprogressAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().InProgressAudiosState.currentRequestBody,
      PageNum: getState().InProgressAudiosState.pagination.page,
    };

    const response = await post("/packs/search", "Transcribe", reqBody);

    return {
      data: response.data.results,
      hasMore: response.data.results.length > 0,
    };
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Search InprogressAudios
export const searchInProgressAudios = createAsyncThunk<any, { searchKeyword: string }, { state: RootState }>("transcribe/searchInProgressAudios", async (args, { getState, dispatch }) => {
  dispatch(resetInProgressTable());
  dispatch(
    updateInProgressRequestBody({
      ...getState().InProgressAudiosState.currentRequestBody,
      Keyword: getState().TranscribeState.searchKeyword,
    })
  );
  dispatch(fetchInprogressAudios({}));
});

//Fetching the RefreshInProgress

export const fetchRefreshInProgress = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchRefreshInProgress", async (args, { getState, dispatch, rejectWithValue }) => {
  const currentDataLength = getState().InProgressAudiosState.data.length === 0 ? 30 : getState().InProgressAudiosState.data.length;
  try {
    const reqBody = {
      ...getState().InProgressAudiosState.currentRequestBody,
      pageSize: Math.ceil(currentDataLength / 30) * 30,
    };

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Auto Refreshing the Inprogress Audios
export const autoRefreshInProgressAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/autoRefreshInProgressAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().InProgressAudiosState.autoRefreshInProgressState.currentIntervalId) {
    clearInterval(getState().InProgressAudiosState.autoRefreshInProgressState.currentIntervalId);
  }
  if (getState().InProgressAudiosState.autoRefreshInProgressState.autoRefresh) {
    const intervalId = setInterval(() => {
      dispatch(fetchRefreshInProgress({}));
    }, autoRefreshFrequency);
    dispatch(setInProgressAutoRefresh({ intervalId }));
  }
});

// Start the generic actions for Audios
export const resetInProgressTable = createAction("transcribe/resetInProgressTable");
export const updateInProgressRequestBody = createAction<DefaultInProgressRequestBodyType>("transcribe/updateInProgressRequestBody");
export const stopInProgressAutoRefresh = createAction("transcribe/stopInProgressAutoRefresh");
export const setInProgressAutoRefresh = createAction<{ intervalId: NodeJS.Timer }>("transcribe/setInProgressAutoRefresh");
export const switchInProgressAutoFresh = createAction<{ autoRefresh: boolean }>("transcribe/switchInProgressAutoFresh");
export const resetPackRequestor = createAction("transcribe/resetPackRequestor");
// End the generic actions for Audios

// Modal actions
export const openDocumentInfoModal = createAction("transcribe/openDocumentInfoModal");
export const closeDocumentInfoModal = createAction("transcribe/closeDocumentInfoModal");
export const openDeleteModal = createAction("transcribe/openDeleteModal");
export const closeDeleteModal = createAction("transcribe/closeDeleteModal");
export const openUnlockModal = createAction("transcribe/openUnlockModal");
export const closeUnlockModal = createAction("transcribe/closeUnlockModal");

//PackDetailsFetch
export const fetchPackDetail = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPackDetail", async (packId, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/packs/${packId}`, "Transcribe");
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});
//Edit Modal Changes Save Button Enable
export const setIsEditedForDocumentInfoModal = createAction<boolean>("transcribe/setIsEditedForDocumentInfoModal");

//Save Pack
export const updatePack = createAsyncThunk<any, { packDetail: any; idPack: number }, { state: RootState }>("transcribe/updatePack", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    notification.destroy();
    const response = await patch(`/packs/${args.idPack}`, "Transcribe", { ...args.packDetail });
    openNotification("Pack Details Updated", `Pack details for '${args.packDetail.fileName}' has been updated successfully,`, "top");
    return response.data;
  } catch (e: any) {
    openStaticErrorNotification("Failed to update Pack details.", e.response.data.detailedMessages, "top");
    return rejectWithValue(e);
  }
});

//Delete Pack
export const delPack = createAsyncThunk<any, { idPack: any }, { state: RootState }>("transcribe/delPack", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    notification.destroy();
    const response = await del(`/packs/${args.idPack}`, "Transcribe");
    openNotification("Pack Deleted", `Pack with ID '${args.idPack}' has been deleted successfully.,`, "top");
    return response.data;
  } catch (e: any) {
    openStaticErrorNotification("Failed to delete  Pack .", e.response.data.detailedMessages, "top");
    return rejectWithValue(e);
  }
});

//Unlock the job
export const unlockPack = createAsyncThunk<any, { idPack: number }, { state: RootState }>("transcribe/unlockPack", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    notification.destroy();
    const response = await patch(`/packs/${args.idPack}/unlock`, "Transcribe", {});
    openNotification("Pack Unlocked", `The pack with ID '${args.idPack}' has been successfully unlocked.`, "top");
    return response.data;
  } catch (e: any) {
    openStaticErrorNotification("Failed to unlock Pack .", e.response.data.detailedMessages, "top");
    return rejectWithValue(e);
  }
});

export const setCurrentRecord = createAction<any>("transcribe/setCurrentRecord");

//THE STATIC METHOD OF FILTERING FROM HERE TO DWON TO BE REMOVED FOR IMPLEMENTING DROPDOWN
